let notices = require( './notices' );

let feedback_form = ( function ( $ ) {

	let $form;

	let _init = function () {
		$form = $( '#feedback-form' );

		if ( $form.length > 0 ) {
			$form.on( 'submit', _submit );
		}
	};

	let _submit = function( e ) {
		e.preventDefault();
		e.stopImmediatePropagation();

		$form.loading();

		let data = new FormData( $form.get( 0 ) );
		data.append( 'action', 'vibe_cake_masters_feedback_form_ajax_submit' );
		data.append( 'nonce', VibeCakeMastersScriptData.vibe_cake_masters_feedback_form_ajax_submit_nonce );

		$.ajax( {
			type: 'POST',
			url: VibeCakeMastersScriptData.ajaxurl,
			data: data,
			success: _submit_response,
			processData: false,
			contentType: false
		} );
	};

	let _submit_response = function( response ) {
		$form.loaded();

		if ( response.success ) {
			notices.add_notice( $form.find( '.notices-wrapper' ), 'success', 'Thank you! Redirecting...', true );
			window.location.href = response.redirect;
		} else {
			notices.add_notice( $form.find( '.notices-wrapper' ), 'error', response.error, true );
		}
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = feedback_form;